export const defaultData = {
	username: '',
	password: '',
	first_name: '',
	last_name: '',
	phone_number: '',
	birth_date: '',
}
